<template>
    <div>
        <vue-headful title="ePlato"/>
        <student-krok-results></student-krok-results>
    </div>
</template>

<script>
    import StudentKrokResults from "../../components/finalExam/studentDashboard/StudentKrokResults";

    export default {
        components: {
            StudentKrokResults,
        },
        data: () => ({
        }),
        
    }
</script>